// Entry point for the build script in your package.json
import "./builder/customerAuthHandoff"
import "./builder/index.jsx"
import { installLocalTime } from "./shared/localTime"

installLocalTime()
